export default 'Artisans RGE — Mandataire CEE | Solution Éco France';
